import { baseUrl } from "@/services/constants.js";
import axios from "axios";
import router from "../router";

export default {
    namespaced: true,

    state: {
        token: localStorage.getItem('token') || '',
        user: {},
        listOfUsers: [],
        userDetail: {},
        userDetailDialog: false,
        stat: {}

    },

    getters: {
        isLoggedIn: (state) => {
            if (state.token) {
                return true
            } else return false
        },
        loggedInUser: (state) => state.user,
        getToken: (state) => state.token || localStorage.getItem('token'),
        isAdmin: (state) => {
            return state.user != null ? (state.user.role ? state.user.role === 'admin' : false) : false;
        },
    },

    mutations: {
        auth_success(state, data) {
            state.user = data.data.user
            state.token = data.token
            router.push("/home")
        },
        logout(state) {
            router.replace('/')
            localStorage.removeItem('token')
            localStorage.clear();

            state.user = Object.assign({}, {})
            state.userDetail = Object.assign({}, {})
        },
        createUserList(state, ulist) {
            state.listOfUsers = ulist
        },
        //updateUser
        updateUser(state, userData) {
            // var idx = state.listOfUsers.findIndex(x => x._id === userData._id);
            // state.listOfUsers[idx] = userData
            // arr1.map(obj => arr2.find(o => o.id === obj.id) || obj);
            state.user = userData
        },
        // deleteUser
        deleteUser(state, userId) {
            var idx = state.listOfUsers.findIndex(x => x._id === userId);
            state.listOfUsers.splice(idx, 1);
        },
        // userDetail
        userDetail(state, detail) {
            state.userDetail = detail
        },
        setStatData(state, payload) {
            state.stat = payload
        }
    },

    actions: {
        async login({ commit }, data) {
            try {
                const resp = await axios.post(baseUrl + "auth/login", data)
                if (resp != null) {
                    localStorage.setItem('token', resp.data.token)
                    commit('auth_success', resp.data)
                }
            } catch (e) {
                commit('logout')
                localStorage.removeItem('token')
            }
        },

        logout({ commit }) {
            commit('logout')
            delete axios.defaults.headers.common['Authorization']
        },

        async signup({ commit }, data) {
            try {
                const resp = await axios.post(baseUrl + "auth/signup", data)
                if (resp != null) {
                    localStorage.setItem('token', resp.data.token)
                    commit('auth_success', resp.data)
                    router.push('/dashboard')

                }
            } catch (e) {
                commit('logout')
                localStorage.removeItem('token')
            }
        },
        async updateProfile({ commit }, data) {
            try {
                const resp = await axios.patch(baseUrl + "auth/profile", data)
                if (resp != null) {
                    commit('updateUser', resp.data.user)
                    commit("notification", { status: true, text: "Profile Updated Successfuly!", color: "cyan darken-2" }, { root: true })
                }
            } catch (e) {
                console.log("Error:= " + e)
            }
        },

        // async updatePP(){},

        async getAllUsers({ commit }) {
            try {
                const resp = await axios.get(baseUrl + "users")
                if (resp != null) {
                    commit("createUserList", resp.data.data.docs)
                }
            } catch (e) {
            }
        },

        async updateUser({ commit }, userData) {
            try {
                const resp = await axios.patch(baseUrl + "users/" + userData._id, userData)
                if (resp != null) {
                    commit("updateUser", userData)
                    commit("notification", { status: true, text: "User Data Updated Successfuly!", color: "cyan darken-2" }, { root: true })
                }
            } catch (e) {
                commit("notification", { status: true, text: "Failed to Update User data!", color: "error darken-2" }, { root: true })
            }
        },

        async deleteUser({ commit }, userId) {
            try {
                const resp = await axios.delete(baseUrl + "users/" + userId)
                if (resp != null) {
                    commit("deleteUser", userId)
                    commit("notification", { status: true, text: "User Deleted Successfuly!", color: "cyan darken-2" }, { root: true })
                }
            } catch (e) {
                commit("notification", { status: true, text: "Failed to Delete User!", color: "error darken-2" }, { root: true })

            }
        },

        async showUser({ commit }, userId) {
            try {
                const resp = await axios.get(baseUrl + "users/" + userId)
                if (resp != null) {
                    commit("userDetail", resp.data.data.doc)
                }
            } catch (e) {
                console.log("USER ERROR:= " + e)
            }
        },

        async getSummary({ commit }) {
            try {
                const resp = await axios.get(baseUrl + "stats/dashboard")
                if (resp != null) {
                    commit("setStatData", resp.data.stats)
                }
            } catch (e) {
                console.log("Error:= " + e)
            }
        }
    }
}